export default function ({ $axios, store }) {
  if (process.client) {
    const token: string | null = window.localStorage.getItem("jwt");
    $axios.setToken(token, "Bearer");
  }
}
